import { useEffect } from "react";
import { AnyBlock } from "../types";
import starterBlocks from "../data/starterblocks.json";

export function useStarterBlocks(
  blockIds: string[],
  upsertBlock: (b: AnyBlock, raise?: boolean) => void
) {
  useEffect(() => {
    if (!blockIds || blockIds.length === 0) {
      Object.keys(starterBlocks).forEach((blockId: string) => {
        (starterBlocks as any)[blockId]["madeBy"] = "seeded";
      });
      importBlocks(starterBlocks, upsertBlock);
    }
  }, [blockIds, upsertBlock]);
}

export function importBlocks(
  starterBlocks: any,
  upsertBlock: (b: AnyBlock, raise?: boolean) => void
) {
  console.log("importing starter blocks");

  Object.keys(starterBlocks).forEach((blockId: string) => {
    let block = (starterBlocks as any)[blockId] as AnyBlock;
    upsertBlock(block, false);
  });
  // hack, to prevent this code from re-triggering if all blocks are deleted
  upsertBlock({
    id: "placeholder-block",
    position: { x: -100, y: -100 },
    size: { width: 0, height: 0 },
    type: "image",
    value: "",
    updatedAt: 0,
  });
}
